













































import { buildAllowedMailDomain } from '@spa/components/organisms/inquiry/model/InquiryComplete'
import { HlAppModeMixin } from '@spa/mixins/hl-app-mode'
import { Validator } from 'vee-validate'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Inject, Prop } from 'vue-property-decorator'
import { InquiryForm } from '../organisms/inquiry/model/InquiryKind'

import SpaCharacter from '@/components/organisms/Character.vue'
import BehaviorConfig from '@/models/app-config/behavior/behavior'

@Component({
  components: {
    SpaCharacter,
  },
})
export default class InquiryComplete extends Mixins<HlAppModeMixin>(HlAppModeMixin) {
  @Inject()
  $validator: Validator

  @Prop({ required: true })
  form: InquiryForm

  behaviorConfig = new BehaviorConfig()

  get mailDomain (): string {
    return buildAllowedMailDomain(this.behaviorConfig)
  }

  get backButtonLabel(): string {
    return this.hlAppMode.isViewedInHlAppWebView
      ? '戻る'
      : 'TOPへ戻る'
  }

  onClickBackButton() {
    if (this.hlAppMode.isViewedInHlAppWebView) {
      this.goToMyPage()

      return
    }

    location.href = '/'
  }
}
